module.exports = __webpack_public_path__ + "static/media/heroBannerParticles.2ae04155.svg";